import './make-one-time-payment-alert.scss';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Alert } from '@sola/ark-core/molecules/alert/alert.tsx';

import { MakeAPaymentSheet } from '../../organisms/make-a-payment/make-a-payment-sheet.tsx';
import { LocalAlertsProvider } from '../local-alerts/local-alerts-provider.tsx';
import {
  type MakeOneTimePaymentAlertProps,
  useMakeOneTimePaymentAlert,
} from './make-one-time-payment-alert.logic.ts';

export const MakeOneTimePaymentAlert = (
  props: MakeOneTimePaymentAlertProps,
) => {
  const { t } = useTranslation('my');
  const [isMakeAPaymentOpen, setIsMakeAPaymentOpen] = useState(false);
  const eligibleCommitments = useMakeOneTimePaymentAlert(props);

  if (eligibleCommitments.length === 0) {
    return null;
  }

  return (
    <LocalAlertsProvider>
      <Alert
        variant="warning"
        className="MakeOneTimePaymentAlert"
        noIcon
        title={t('payments.makeOneTimePaymentAlert.title')}
        message={t('payments.makeOneTimePaymentAlert.message')}
        buttonAction={
          <button type="button" onClick={() => setIsMakeAPaymentOpen(true)}>
            {t('payments.makeOneTimePaymentAlert.cta')}
          </button>
        }
      />
      <MakeAPaymentSheet
        open={isMakeAPaymentOpen}
        onOpenChange={setIsMakeAPaymentOpen}
      />
    </LocalAlertsProvider>
  );
};
